/**
 * @group Auth
 * @summary Authentication event types and reporting constants
 * 
 * @remarks
 * This constant contains event types and values used in authentication reporting,
 * including event types, names, domains, features, actions, methods, and environment values.
 * 
 * @example
 * ```typescript
 * import { AUTH_EVENTS } from '@shared/constants';
 * 
 * reportEvent({
 *   type: AUTH_EVENTS.TYPES.SIGNIN,
 *   name: AUTH_EVENTS.NAMES.SIGN_IN,
 *   domain: AUTH_EVENTS.DOMAINS.AUTH,
 *   feature: AUTH_EVENTS.FEATURES.SIGN_IN,
 *   action: AUTH_EVENTS.ACTIONS.SUCCESS,
 *   method: AUTH_EVENTS.METHODS.CREDENTIALS
 * });
 * ```
 */
export const /**
 * @internal
 */
AUTH_EVENTS = {
  TYPES: {
    SIGNIN: 'signin'
  },
  NAMES: {
    SIGN_IN: 'auth:sign_in'
  },
  DOMAINS: {
    AUTH: 'auth'
  },
  FEATURES: {
    SIGN_IN: 'sign_in'
  },
  ACTIONS: {
    SUCCESS: 'success'
  },
  METHODS: {
    CREDENTIALS: 'credentials'
  },
  ENV_VALUES: {
    TRUE: 'true'
  }
} as const; 